import React from 'react';
import styled from '@emotion/styled';

import { CloseButtonHeader } from '../../header/CloseButtonHeader';
import { BackButtonHeader } from '../../header/BackButtonHeader';
import { ProgressBar } from '../../progressBar/ProgressBar';

type Props = {
  title: string,
  titleAriaHidden?: boolean,
  titleIcon?: Node | string,
  titleId?: string,
  titleCentered?: boolean,
  handleClose: Function,
  hasCloseButton?: boolean,
  headerInView: boolean,
  progressValue?: number,
  onBackButtonClick?: Function,
  isStickyOnFullScreen?: boolean,
  isFullScreen?: boolean,
  mode?: string,
  buttonAriaLabel?: string,
};

export const RegularHeader = ({
  title,
  titleAriaHidden,
  titleIcon,
  titleId,
  titleCentered,
  handleClose,
  hasCloseButton,
  buttonAriaLabel,
  headerInView,
  progressValue,
  onBackButtonClick,
  isStickyOnFullScreen,
  isFullScreen,
  mode = 'Modal',
}: Props) => {
  return (
    <Wrapper>
      {onBackButtonClick ? (
        <BackButtonHeader titleAriaHidden={titleAriaHidden} title={title} onClick={onBackButtonClick} />
      ) : (
        <CloseButtonHeaderWrapper
          isFixedOnMobile={!isStickyOnFullScreen && isFullScreen}
          isSticky={isStickyOnFullScreen && isFullScreen}
          title={title}
          iconLeft={titleIcon}
          titleAriaHidden={titleAriaHidden}
          titleId={titleId}
          titleCentered={titleCentered}
          handleCloseClick={hasCloseButton ? handleClose : null}
          hasShadow={!headerInView}
          data-test="close-modal-button"
          mode={mode}
          progressValue={progressValue}
          closeButtonAriaLabel={buttonAriaLabel}
        />
      )}

      {progressValue > 0 && <ProgressBar value={progressValue} mode="ModalHeader" height="4px" />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-size: 0;
  position: relative;
  width: 100%;
`;

const CloseButtonHeaderWrapper = styled(CloseButtonHeader)`
  flex-basis: auto;

  ${({ theme, isFixedOnMobile }) =>
    isFixedOnMobile &&
    `
      visibility: hidden;
      position: fixed;
      left: 0;

      @media (${theme.breakpoint.desktop}) {
        visibility: visible;
        position: relative;
      }
    `}
`;
